import { useEffect, useRef } from "react";
import Header from "@components/shared/header/Header";
import { AppSidebar } from "@components/navigation";
import { usePage } from "@inertiajs/react";
import { WorkflowProvider } from "@context/WorkflowProvider";
import { CreditWarningModal } from "@components/credits";
import { AppErrorBoundary } from "@components/shared/AppErrorBoundary";
import { PageProviders } from "./page-providers";

// Re-export shared types so existing imports from "~/layouts/site-layout" keep working.
export type { SharedPageProps, FlashMessage } from "./types";

export const SiteLayout = ({ children }: { children: React.ReactNode }): React.ReactNode => {
  return (
    <PageProviders>
      <SiteChrome>{children}</SiteChrome>
    </PageProviders>
  );
};

// Chrome-only concerns: sidebar, header, workflow context, credit warning
// modal, scroll-to-top on route change. Runs inside PageProviders.
function SiteChrome({ children }: { children: React.ReactNode }) {
  const { url } = usePage();
  const mainRef = useRef<HTMLElement>(null);

  useEffect(() => {
    mainRef.current?.scrollTo(0, 0);
  }, [url]);

  return (
    <WorkflowProvider>
      <div className="flex h-screen overflow-hidden">
        <AppSidebar />
        <div className="flex-1 flex flex-col bg-background overflow-hidden">
          <Header />
          <main ref={mainRef} className="flex-1 overflow-auto">
            <AppErrorBoundary>{children}</AppErrorBoundary>
          </main>
        </div>
      </div>
      <CreditWarningModal />
    </WorkflowProvider>
  );
}
